/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bo as Bo,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_nA_110_65(e) {
  let t = (0, ReactCompiler.c)(10),
    { titulo: n, ayuda: r, children: i } = e,
    a;
  t[0] === n
    ? (a = t[1])
    : ((a = (
        <h2 className={`text-sm font-semibold text-(--text-h)`} children={n} />
      )),
      (t[0] = n),
      (t[1] = a));
  let o;
  t[2] === r
    ? (o = t[3])
    : ((o = r && <p className={`mt-0.5 text-xs text-(--text)`} children={r} />),
      (t[2] = r),
      (t[3] = o));
  let s;
  t[4] !== a || t[5] !== o
    ? ((s = <div children={[a, o]} />), (t[4] = a), (t[5] = o), (t[6] = s))
    : (s = t[6]);
  let c;
  return (
    t[7] !== i || t[8] !== s
      ? ((c = (
          <section className={`${Bo} flex flex-col gap-3`} children={[s, i]} />
        )),
        (t[7] = i),
        (t[8] = s),
        (t[9] = c))
      : (c = t[9]),
    c
  );
}
